import { calcProduction } from '../data';

export const captureStateSnapshot = (state, planetId) => ({
  resources: JSON.parse(JSON.stringify(state.planets[planetId].resources)),
  production: calcProduction(state, planetId),
  buildings: JSON.parse(JSON.stringify(state.planets[planetId].buildings)),
  ships: JSON.parse(JSON.stringify(state.planets[planetId].ships)),
  research: JSON.parse(JSON.stringify(state.research)),
});

// Replaces the legacy module-level mutable `plot_data` global (which was
// reset at the top of every GameReducer() call) with an instance created
// fresh per call and threaded through explicitly, so simulation runs never
// share or leak state across calls/re-entrancy.
export const createPlotRecorder = () => {
  const plotData = {};
  return {
    record(state, planetId, label) {
      const time = state.planets[planetId].time;
      if (!plotData[planetId]) plotData[planetId] = [];
      plotData[planetId].push({ time, label, snapshot: captureStateSnapshot(state, planetId) });
    },
    data() {
      return plotData;
    },
  };
};
